const sliderInits = () => {
	//Gallery Slider Module
	var slideCount = $('.gallery__slider-item').length;
	$('.js__gallery-slider').on('init', function(event, slick){
		var progressWidth = (100 / slideCount) + '%';
	  	
	  	$('.gallery__slider-progress-bar span').css('width', progressWidth);
	});	

	$('.js__gallery-slider').slick({
		centerMode: true,
		centerPadding: '22%',
		arrows: false,
		dots: false,
	  	responsive: [
	  		{
	      		breakpoint: 1199,
	      		settings: {
			        centerPadding: '18%'
		      	}
		    },
		    {
	      		breakpoint: 991,
	      		settings: {
		        	centerPadding: '15%'
		      	}
		    },
		    {
	      		breakpoint: 767,
	      		settings: {
		        	centerPadding: '13%'
	      		}
		    }
	    ]
	});
    
	$('.js__gallery-slider').on('afterChange', function(event, slick, currentSlide){
		var slideIndex = currentSlide + 1;
		var progressWidth = ((slideIndex / slideCount) * 100) + '%';

		$('.gallery__slider-progress-bar span').css('width', progressWidth);
	});	

	$('.gallery__slider-arrow--prev').on('click', function(e) {
		e.preventDefault;

		$('.js__gallery-slider').slick('slickPrev');
	});

	$('.gallery__slider-arrow--next').on('click', function(e) {
		e.preventDefault;

		$('.js__gallery-slider').slick('slickNext');
	});

	//Staggered CTA Slider
	if ( $('.js__staggered-cta-slider').length ) {
		var $staggered_slider = $('.js__staggered-cta-slider');
		var settings = {
			dots: false,
			arrows: true,
			slidesToShow: 2,
		  	responsive: [
		  		{
		      		breakpoint: 767,
		      		settings: {
				        slidesToShow: 1
			      	}
			    }
		    ]			
		};

		if ( $(window).width() < 991 ) {
			$staggered_slider.slick(settings);
		}

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() > 991 ) {
				if ($staggered_slider.hasClass('slick-initialized')) {
					$staggered_slider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() < 991 ) {
				if (!$staggered_slider.hasClass('slick-initialized')) {
					return $staggered_slider.slick(settings);
				}
			}
		});		
	}
};